import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/services/auth/authentication.service';

@Injectable()
export class HttpTokenInterceptorService implements HttpInterceptor {
  constructor(private authenticationService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // All HTTP requests are going to go through this method
    // const user = this.authenticationService.userValue;
    const isLoggedIn = this.authenticationService.userValue || localStorage.getItem('accessToken')

    if (isLoggedIn) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
    }
    return next.handle(req);
  }
}
